/**
 * tdesign v0.44.2
 * (c) 2022 tdesign
 * @license MIT
 */

import { _ as _slicedToArray } from '../_chunks/dep-784849f3.js';
import { useState } from 'react';
import { u as upperFirst_1 } from '../_chunks/dep-41dfd063.js';
import noop from '../_util/noop.js';
import '../_chunks/dep-d6cc3db8.js';
import '../_chunks/dep-7a9656a6.js';
import '../_chunks/dep-0b195c48.js';
import '../_chunks/dep-04371a7c.js';
import '../_chunks/dep-935ff614.js';
import '../_chunks/dep-da112583.js';
import '../_chunks/dep-dfae10c3.js';
import '../_chunks/dep-1792ab93.js';
import '../_chunks/dep-4929b64e.js';
import '../_chunks/dep-1e4c771d.js';

var useControlled = function useControlled() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var valueKey = arguments.length > 1 ? arguments[1] : undefined;
  var onChange = arguments.length > 2 ? arguments[2] : undefined;
  var defaultOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var controlled = Reflect.has(props, valueKey);
  var value = props[valueKey];
  var defaultValue = defaultOptions["default".concat(upperFirst_1(valueKey))] || props["default".concat(upperFirst_1(valueKey))];
  var _useState = useState(defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    internalValue = _useState2[0],
    setInternalValue = _useState2[1];
  if (controlled) return [value, onChange || noop];
  return [internalValue, function (newValue) {
    setInternalValue(newValue);
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    onChange === null || onChange === void 0 ? void 0 : onChange.apply(void 0, [newValue].concat(args));
  }];
};

export { useControlled as default };
//# sourceMappingURL=useControlled.js.map
